'use client'

import { motion } from 'framer-motion'
import {
  ThumbsUp,
  Clock,
  Languages,
  Palette,
  HandCoins,
  FileText
} from 'lucide-react'
import { useTranslations } from 'next-intl'
import '../../sass/landing/BenefitsSection.scss'

type BenefitKey = 'easy' | 'instant' | 'languages' | 'customize' | 'free' | 'pdf'

const benefits: Array<{ key: BenefitKey; icon: typeof ThumbsUp }> = [
  { key: 'easy', icon: ThumbsUp },
  { key: 'instant', icon: Clock },
  { key: 'languages', icon: Languages },
  { key: 'customize', icon: Palette },
  { key: 'free', icon: HandCoins },
  { key: 'pdf', icon: FileText }
]

const BenefitsSection = () => {
  const t = useTranslations('LandingV2.benefits')

  return (
    <section className='benefits'>
      <div className='benefits__container'>
        <div className='benefits__header'>
          <h2>
            {t.rich('heading', {
              highlight: (chunks) => <span className='benefits__highlight'>{chunks}</span>
            })}
          </h2>
          <p>
            {t.rich('subtitle', {
              bold: (chunks) => <span className='benefits__bold'>{chunks}</span>
            })}
          </p>
        </div>

        <div className='benefits__grid'>
          {benefits.map(({ key, icon: Icon }, i) => (
            <motion.div
              key={key}
              className='benefits__card'
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: i * 0.05, ease: [0.16, 1, 0.3, 1] }}
            >
              <div className='benefits__icon' aria-hidden='true'>
                <Icon size={22} strokeWidth={1.75} />
              </div>
              <h3 className='benefits__title'>{t(`items.${key}.title`)}</h3>
              <p className='benefits__desc'>{t(`items.${key}.description`)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default BenefitsSection
